// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xersesvtomrjazwgniqz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhlcnNlc3Z0b21yamF6d2duaXF6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzcxOTczNzksImV4cCI6MjA1Mjc3MzM3OX0.qp516ENBcqwbg4EX4ya8elcAIxDMTaFzZy_W3GzobLM";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true
  }
});